/**
 * Array utility functions.
 * Replaces the previous Array.prototype mutation to prevent prototype pollution.
 */

export function addLabelValue(arr, labelKey, valueKey) {
    return arr.map(item => ({
        ...item,
        label: item[labelKey],
        value: item[valueKey],
    }));
}

export function insertAt(arr, index, item) {
    const copy = [...arr];
    copy.splice(index, 0, item);
    return copy;
}

export function removeItem(arr, elem) {
    const indexElement = arr.findIndex(el => el === elem);
    if (indexElement !== -1) {
        const copy = [...arr];
        copy.splice(indexElement, 1);
        return copy;
    }
    return arr;
}

  


